export default "__VITE_ASSET__17548793__"